var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tooltip',{staticClass:"has-margin-right-25",attrs:{"label":_vm.label,"type":"is-primary"}},[_c('b-icon',{staticClass:"has-cursor-help",attrs:{"icon":"check-circle","type":"is-primary","size":"is-small"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }